import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ProgramsSection from './components/ProgramsSection';
import ListenGuideSection from './components/ListenGuideSection';
import SocialSection from './components/SocialSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    // Set canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', siteUrl);
    
    // Set OG URL
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', siteUrl);
    
    // Add Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: "Windie's Mania SHABADABA",
          description: '小劇団、インディーズ歌手、自主映画などマイナーだけど魅力的なインディーズカルチャーを紹介するコミュニティFMラジオ番組',
          inLanguage: 'ja'
        },
        {
          '@type': 'RadioSeries',
          '@id': `${siteUrl}/#radioseries`,
          name: "Windie's Mania SHABADABA",
          description: '小劇団、インディーズ歌手、自主映画などマイナーだけど魅力的なインディーズカルチャーを紹介するコミュニティFMラジオ番組。毎週火曜18:30から83.6MHzで放送中。',
          genre: ['インディーズ音楽', '小劇団', '自主映画', 'カルチャー'],
          inLanguage: 'ja',
          broadcastFrequency: '83.6 MHz',
          url: siteUrl
        },
        {
          '@type': 'Organization',
          '@id': `${siteUrl}/#organization`,
          name: "Windie's Mania SHABADABA",
          url: siteUrl,
          logo: 'https://static.readdy.ai/image/f493cbe5c2084134677121347fdba237/67b39ddc318dd3ffa5c638582fb9d352.png',
          sameAs: [
            'https://x.com/windies_mania',
            'https://www.instagram.com/eiji_hoshino',
            'https://www.youtube.com/@windiesmaniayoutuber6926',
            'https://note.com/windies_mania'
          ]
        }
      ]
    });
    document.head.appendChild(schemaScript);
    
    return () => {
      if (schemaScript.parentNode) {
        schemaScript.parentNode.removeChild(schemaScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a1628] via-[#1a2642] to-[#0a1628]">
      <Header scrolled={scrolled} />
      <HeroSection />
      <AboutSection />
      <ProgramsSection />
      <ListenGuideSection />
      <SocialSection />
      <ContactSection />
      <Footer />
    </div>
  );
}